import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import FooterContainer from 'src/components/footer/footer';
import Slider from "react-slick";

function LiveCasinoLeaguePromo (props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const settings = {
        loop: true,
        arrows: true,
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        initialSlide: 0,
        centerPadding: '20px'
    };

    const domain = (brandId == 31 || brandId == 32 || brandId == 61) ? "YOLO247" : (brandId == 39 || brandId == 40) ? "FOMO7" : (brandId == 46 || brandId == 47) ? "FUN88" : 'IW247';

    return (
        <>
            <InformationWrapper>
                <Container>
                    <p>This July to August, experience the thrill of live dealers and real wins with <strong>{domain}</strong> and <strong>Evolution</strong>. Compete in the <strong>Live Casino League</strong> and claim <br /> your share in the Weekly and monthly prizes.</p>
                </Container>

                <Container>
                        <MainTitle>How to Participate</MainTitle>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeagueDeskFirstSec}`}
                            alt="How to participate"
                            effect="none"
                            width="707"
                            placeholder={<PlaceholderImage />}
                        />
                </Container>

                <Container className='morePadding'>
                    <MainTitle>Weekly Prize Pool</MainTitle>
                    <SliderWrapper>
                        <Slider {...settings}>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeague1st}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeague2nd}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeague3rd}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeague4th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeague5th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeague6th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeague7th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeague8th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeague9th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeague10th}`}/></div>
                        </Slider>
                    </SliderWrapper>
                </Container>

                <Container>
                    <MainTitle>Monthly prize Pool</MainTitle>
                    <KeyDetailsSecWrap>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.liveCasinoLeagueMonthlyPricePool}`}
                            alt="Monthly prize Pool"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </KeyDetailsSecWrap>
                    <p className='textNormal'>(Random selector from top players in the weekly leaderboard)</p>
                </Container>
                <TermsAndCondition>
                    <MainTitle>Terms &amp; Conditions</MainTitle>
                    <ul>
                        <li>Only real money wagers on Evolution Live Casino games qualify.</li>
                        <li>Leaderboards are based on total turnover (not profit/loss).</li>
                        <li>Weekly prizes are paid as bonuses</li>
                        <li>Winners must complete KYC and provide a valid USDT wallet address if required</li>
                        <li>Leaderboards reset at midnight Weekly (IST).</li>
                        <li>Rewards are subject to internal verification and audit.</li>
                        <li>Fraudulent behaviour may result in disqualification.</li>
                        <li>{domain} reserves the right to update or terminate the campaign at its discretion.</li>
                    </ul>
                </TermsAndCondition>
                <Container>
                    <p>Join the Live Casino League, face the dealer, and claim your place at the top&#33;</p>
                </Container>
            </InformationWrapper>
            <FooterContainer />
        </>
    )
}

export default withTheme(withAppContext(LiveCasinoLeaguePromo));

// Styled Component.
const TermsAndCondition = styled.div`
    width: 100%;
    max-width: 1120px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 2rem 0;
    gap: 1.7rem;
    border-radius: 9.945px;
    background: #FFF;

    ul {
        padding: 0;
        list-style: decimal;
        width: 80%;
        display: flex;
        flex-direction: column;
        gap: 10px;

        li {
            color: #444;
            text-align: left;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            text-transform: capitalize;
        }
    }
`;

const SliderWrapper = styled.div`
    width: 85%;
    margin: 0 auto;

    .slick-slide {
        padding: 0 15px;
    }

    .slick-slide img {
        display: block;
        width: 100%;
        transition: transform .5s; /* Animation */

        :hover {
            transform: scale(0.8);
            border: 3px solid #ffffff;
            border-radius: 1rem;
        }

        :focus-visible {
            outline: none;
        }
        :focus {
            outline: none;
        }
    }

    .slick-prev {
        left: -65px;
        top: 43%;
    }

    .slick-next {
        right: -25px;
        top: 43%;
    }

    .slick-prev:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/prevSlideJackpotFun.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-next:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/nextSlideJackpotFun.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-dots {
        bottom: -40px;

        li {
            margin: 0 0px;
        }

        li button:before {
            color: #EBEBEB;
            font-size: 13px;
            opacity: unset;
        }

        li.slick-active button:before {
            opacity: unset;
            color: ${theme('palette.slickActiveButtonClr')};
        }
    }
`;

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 3rem;
    padding-top: 1.2rem;
    background: rgba(111, 111, 111, 0.5);
    margin: 0em;
    border-top-color: transparent;
    backdrop-filter: brightness(0.5);    
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    background-color: #EBEBEB;
    text-align: center;

    .hTitle {
        font-size: 36px;
        font-style: normal;
        font-weight: 700;
        color: #06A6FF;
        text-align: center;
        text-transform: capitalize;
    }

    strong {
        color: #444444;
        font-weight: 700;
    }

    p {
        color: #444;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        margin: 0;
    }

    .textNormal {
        font-size: 20px;
        font-weight: 600;
        color: #06A6FF;
    }
`;

const Container = styled.div`
    width: 100%;
    max-width: 1120px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 2rem 0;
    gap: 1.7rem;
    border-radius: 9.945px;
    background: #FFF;

    &.morePadding {
      padding-bottom: 4rem;
    }

`;

const MainTitle = styled.h4`
    color: #06A6FF;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    text-transform: capitalize;
    text-align: center;
    margin: 0;
`

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;

    img {
        width: 600px;
        max-width: 100%;
    }
`
